import * as React from 'react';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import './Tabset.scss';
import { sortType } from 'src/model/modules/invoices.model';
import InvoiceModel from 'src/model/invoice.model';
import { IPaySimpleError } from 'src/store/modules/paysimplepayment/reducers';
import InvoiceFilterBar from '../InvoiceFilterBar';
import OpenInvoices from '../OpenInvoices';
import CalenderIcon from '../../../../assets/calendarIcon';
import CalenderIcon2 from '../../../../assets/calendarIcon2';
import CalenderIcon3 from '../../../../assets/calendarIcon3';
import PaymentIcon from '../../../../assets/payment';
import DollarIcon from '../../../../assets/dollar';
import PaymentMethod from '../PaymentMethod';
import InvoiceFilters from '../InvoiceFilters';
import MobileOpenInvoices from '../MobileOpenInvoices';
import * as moment from 'moment';
import {
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import i18n from 'src/translation/i18n';

export default function DisabledTabs(props: any) {
  const [value, setValue] = React.useState(0);
  const [active, setActive] = React.useState(true);
  const [secondactive, setSecondActive] = React.useState(false);
  const [thirdactive, setThirdActive] = React.useState(false);
  const [fourthactive, setFourthActive] = React.useState(false);
  const [fifthactive, setFifthActive] = React.useState(false);
  const [filtervalues, setfiltervalues] = React.useState();
  const [reset, checkReset] = React.useState(false);
  const [cardActive, SetCardActiveStatus] = React.useState(false);
  const [openFilters, setOpenFilters] = React.useState(false);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const getFilterValues = (dates: any, isHeader?: boolean) => {
    const filters: IFiltersInvoice = {
      dateRange: dates,
      status: null,
      orderStatus: null,
      invoiceNumber: null,
      nardaNumber: null,
      orderNumber: null,
      orderReference: null,
      sort: null
    };
    const pagination: IPaginationInvoice = {
      page: 0
    };
    props.getInvoices(filters, pagination, isHeader);
  };

  React.useEffect(() => {
    if (reset) {
      setActive(true);
      setSecondActive(false);
      setThirdActive(false);
      setFourthActive(false);
      setFifthActive(false);
      checkReset(false);
    }
  }, [reset]);

  const firstcard = () => {
    setSecondActive(false);
    setThirdActive(false);
    setFourthActive(false);
    setFifthActive(false);
    // const temporary1 = !active;
    setActive(true);
    // props.setDates({});
    getFilterValues({});
    // SetCardActiveStatus(true);
  };

  const secondcard = () => {
    const currentdate = new Date();
    // const start = moment(currentdate).subtract(30, 'd');
    // const end = moment(currentdate).subtract(1, 'd');
    const noOfdaysInMonth = new Date(
      currentdate.getFullYear(),
      currentdate.getMonth() + 1,
      0
    ).getDate();
    const start = moment(
      new Date(currentdate.getFullYear(), currentdate.getMonth(), 1)
    );
    // const end = moment(
    //   new Date(
    //     currentdate.getFullYear(),
    //     currentdate.getMonth(),
    //     noOfdaysInMonth
    //   )
    // );
    setActive(false);
    setThirdActive(false);
    setFourthActive(false);
    setFifthActive(false);
    const temporary2 = !secondactive;
    setSecondActive(temporary2);
    if (!temporary2) {
      getFilterValues({});
      // props.setDates({});
      return;
    }
    // props.setDates({ start, end });
    getFilterValues({ start }, true);
    SetCardActiveStatus(true);
  };
  const thirdcard = () => {
    const currentdate = new Date();
    // const start = moment(currentdate).subtract(60, 'd');
    // const end = moment(currentdate).subtract(31, 'd');
    const noOfdaysInMonth = new Date(
      currentdate.getFullYear(),
      currentdate.getMonth(),
      0
    ).getDate();
    const start = moment(
      new Date(currentdate.getFullYear(), currentdate.getMonth() - 1, 1)
    );
    const end = moment(
      new Date(
        currentdate.getFullYear(),
        currentdate.getMonth() - 1,
        noOfdaysInMonth
      )
    );
    setActive(false);
    setSecondActive(false);
    setFourthActive(false);
    setFifthActive(false);
    const temporary3 = !thirdactive;
    setThirdActive(temporary3);
    if (!temporary3) {
      // props.setDates({});
      getFilterValues({});
      return;
    }
    // props.setDates({ start, end });
    getFilterValues({ start, end }, true);
    SetCardActiveStatus(true);
  };
  const fourthcard = () => {
    const temporary4 = !fourthactive;
    setActive(false);
    setSecondActive(false);
    setThirdActive(false);
    setFifthActive(false);
    setFourthActive(temporary4);
    if (!temporary4) {
      // props.setDates({});
      getFilterValues({});
      return;
    }
    const currentdate = new Date();
    // const start = moment(currentdate).subtract(90, 'd');
    // const end = moment(currentdate).subtract(61, 'd');
    const noOfdaysInMonth = new Date(
      currentdate.getFullYear(),
      currentdate.getMonth() - 1,
      0
    ).getDate();
    const start = moment(
      new Date(currentdate.getFullYear(), currentdate.getMonth() - 2, 1)
    );
    const end = moment(
      new Date(
        currentdate.getFullYear(),
        currentdate.getMonth() - 2,
        noOfdaysInMonth
      )
    );
    getFilterValues({ start, end }, true);
    // props.setDates({ start, end });
    SetCardActiveStatus(true);
  };
  const fifthcard = () => {
    const temporary5 = !fifthactive;
    setActive(false);
    setSecondActive(false);
    setThirdActive(false);
    setFourthActive(false);
    setFifthActive(temporary5);
    if (!temporary5) {
      // props.setDates({});
      getFilterValues({});
      return;
    }
    const currentdate = new Date();
    // const end = moment(currentdate).subtract(91, 'd');
    const noOfdaysInMonth = new Date(
      currentdate.getFullYear(),
      currentdate.getMonth() - 2,
      0
    ).getDate();
    // const start = moment(new Date(currentdate.getFullYear(), currentdate.getMonth() - 2, 1));
    const end = moment(
      new Date(
        currentdate.getFullYear(),
        currentdate.getMonth() - 3,
        noOfdaysInMonth
      )
    );
    getFilterValues({ end }, true);
    // props.setDates({ end });
    SetCardActiveStatus(true);
  };

  const { getArSummary } = props;
  React.useEffect(() => {
    getArSummary();
    if (window.innerWidth > 1023) {
      setOpenFilters(true);
    }
  }, []);
  const { arSummaryData } = props;
  return (
    <div className="tab-container">
      <Tabs
        value={value}
        indicatorColor="primary"
        onChange={handleChange}
        aria-label="disabled tabs example"
      >
        <Tab label={i18n.t('invoices.openInvoices')} />
        <Tab label={i18n.t('invoices.paymentHistory')} />
      </Tabs>
      {value === 0 && (
        <>
          <div className="tab-set-container">
            {window.innerWidth <= 1023 && (
              <div className="trigger-wrapper">
                <div className="invoice-filters-trigger grey-bg">
                  <span>Filters</span>
                  <a
                    href="javascript:void(0)"
                    onClick={() => setOpenFilters(!openFilters)}
                  >
                    {!openFilters
                      ? i18n.t('invoices.open')
                      : i18n.t('invoices.close')}
                  </a>
                </div>
              </div>
            )}
            {openFilters && (
              <>
                <div className="d-flex cards-mobile">
                  <div className="invoice-card-container">
                    <div
                      onClick={firstcard}
                      className={`d-flex card-appear ${
                        active === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <div className="img-bg1">
                          <img className="img-icon" src={DollarIcon} />
                        </div>
                      </div>
                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('invoices.totalBalance')}
                        </div>
                        <div
                          className={`card-amount ${
                            active === true ? 'font-weight' : ''
                          }`}
                        >
                          {/* {'$' + arSummaryData?.openArBalance} */}
                          {currencyFormatter(arSummaryData?.openArBalance)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="invoice-card-container">
                    <div
                      onClick={secondcard}
                      className={`d-flex card-appear ${
                        secondactive === true ? 'border2' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <div className="img-bg2">
                          <img className="img-icon" src={PaymentIcon} />
                        </div>
                      </div>
                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('invoices.currentBalance')}
                        </div>
                        <div
                          className={`card-amount ${
                            secondactive === true ? 'font-weight' : ''
                          }`}
                        >
                          {/* {'$' + arSummaryData?.currentMonthBalance} */}
                          {currencyFormatter(
                            arSummaryData?.currentMonthBalance
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="invoice-card-container">
                    <div
                      onClick={thirdcard}
                      className={`d-flex card-appear ${
                        thirdactive === true ? 'border3' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <div className="img-bg3">
                          <img className="img-icon" src={CalenderIcon} />
                        </div>
                      </div>
                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('invoices.thirtyPastDayDue')}
                        </div>
                        <div
                          className={`card-amount ${
                            thirdactive === true ? 'font-weight' : ''
                          }`}
                        >
                          {/* {'$' + arSummaryData?.firstMonthPastDueDate} */}
                          {currencyFormatter(
                            arSummaryData?.firstMonthPastDueDate
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="invoice-card-container">
                    <div
                      onClick={fourthcard}
                      className={`d-flex card-appear ${
                        fourthactive === true ? 'border4' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <div className="img-bg4">
                          <img className="img-icon" src={CalenderIcon2} />
                        </div>
                      </div>
                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('invoices.sixtyPastDayDue')}
                        </div>
                        <div
                          className={`card-amount ${
                            fourthactive === true ? 'font-weight' : ''
                          }`}
                        >
                          {/* {'$' + arSummaryData?.secondMonthPastDueDate} */}
                          {currencyFormatter(
                            arSummaryData?.secondMonthPastDueDate
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="invoice-card-container">
                    <div
                      onClick={fifthcard}
                      className={`d-flex card-appear ${
                        fifthactive === true ? 'border5' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <div className="img-bg5">
                          <img className="img-icon" src={CalenderIcon3} />
                        </div>
                      </div>
                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('invoices.nintyPastDayDue')}
                        </div>
                        <div
                          className={`card-amount ${
                            fifthactive === true ? 'font-weight' : ''
                          }`}
                        >
                          {/* {'$' + arSummaryData?.thirdMonthPastDueDate} */}
                          {currencyFormatter(
                            arSummaryData?.thirdMonthPastDueDate
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex mobile-filters">
                  <InvoiceFilters
                    setfiltervalues={setfiltervalues}
                    checkReset={checkReset}
                    cardActive={cardActive}
                    SetCardActiveStatus={SetCardActiveStatus}
                  />
                </div>
              </>
            )}
            <div className="desktop">
              <OpenInvoices filtervalues={filtervalues} />
            </div>
            {/* {window.innerWidth <= 767 && (
              <div className="mobile">
                <MobileOpenInvoices />
              </div>
            )} */}
          </div>
        </>
      )}
      {value === 1 && <PaymentMethod />}
    </div>
  );
}
// export default DisabledTabs;
